import { Component, DestroyRef, inject, OnInit } from '@angular/core';
import { Meta, Title } from '@angular/platform-browser';
import { AsyncPipe } from '@angular/common';
import { map, Observable, Subject, takeUntil } from 'rxjs';
import { ActivatedRoute } from '@angular/router';
import { environment } from '../../environments/environment';
import { LoyaltyService } from '../../api/services';
import { ReferralProgramCodeInfo } from '../../api/models/referral-program-code-info';

@Component({
  selector: 'app-invitation-view',
  standalone: true,
  imports: [AsyncPipe],
  templateUrl: './invitation.component.html',
  styleUrl: './invitation.component.scss'
})
export class InvitationComponent implements OnInit {
  protected readonly environment = environment;
  protected readonly destroyRef = inject(DestroyRef);
  private loyaltyService = inject(LoyaltyService);
  private metaService = inject(Meta);
  private titleService = inject(Title);
  private route = inject(ActivatedRoute);
  private destroy$ = new Subject<void>();

  public invitation$?: Observable<ReferralProgramCodeInfo>;

  ngOnInit() {
    this.fetchData();

    this.destroyRef.onDestroy(() => {
      this.destroy$.next();
      this.destroy$.complete();
    });
  }

  fetchData() {
    const code = this.route.snapshot.paramMap.get('code');

    if (!code) {
      return;
    }

    this.invitation$ = this.loyaltyService
      .incustControllersClientClientReferralProgramInvitationInfo(code)
      .pipe(
        takeUntil(this.destroy$),
        map((res: any) => {
          console.log('Gift card: ', res);
          this.setMetaTags(res);
          // window.open(
          //   `${environment.CLIENT_URL}/hint/show/${res.code}?lang=${
          //     lang || 'en'
          //   }`,
          //   '_self'
          // );
          return res;
        })
      );
  }

  getUrl(code?: string) {
    if (!code) {
      return '';
    }

    const lang = this.route.snapshot.queryParamMap.get('lang') || null;
    const from = this.route.snapshot.queryParamMap.get('from_src') || null;
    return `${
      from ? 'https://' + from : environment.CLIENT_URL
    }/hint/show/${code}?lang=${lang || 'en'}`;
  }

  setMetaTags(data: ReferralProgramCodeInfo) {
    this.titleService.setTitle(data.loyalty?.public_title || 'Default Title');
    this.metaService.addTags([
      {
        name: 'description',
        content: data.loyalty?.public_description || 'Default description'
      },
      {
        name: 'keywords',
        content: data.loyalty?.public_title || 'angular,ssr,example'
      },
      { name: 'twitter:card', content: 'summary' },
      // {name: 'twitter:site', content: `@`},
      { name: 'og:type', content: 'website' },
      {
        name: 'og:site_name',
        content: data.loyalty?.public_title || 'Default Title'
      },
      {
        name: 'og:title',
        content: data.loyalty?.public_title || 'Default Title'
      },
      {
        name: 'og:url',
        content: this.getUrl(data.code)
      },
      {
        name: 'og:description',
        content: data.loyalty?.public_description || 'Default description'
      },
      { name: 'og:image', content: data.loyalty?.photos?.[0].url || '' },
      { name: 'og:image:width', content: '600' },
      { name: 'og:image:height', content: '315' }
    ]);
    this.metaService.updateTag({
      rel: 'canonical',
      href: this.getUrl(data.code)
    });
  }
}
